"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("@ngrx/store");
var skynet_store_manager_1 = require("@synisys/skynet-store-manager");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var lodash_decorators_1 = require("lodash-decorators");
var Observable_1 = require("rxjs/Observable");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var load_main_entities_action_1 = require("../actions/load-main-entities.action");
function mainEntityKey(_, field) {
    return field.systemName + '--' + field.metaCategoryId.systemName;
}
exports.mainEntityKey = mainEntityKey;
var FieldStoreManager = /** @class */ (function (_super) {
    __extends(FieldStoreManager, _super);
    function FieldStoreManager(path, keyExtractor, prefix) {
        return _super.call(this, path, keyExtractor, prefix) || this;
    }
    FieldStoreManager.prototype.loadMainEntityFields = function (store, metaFieldId, compoundCategory) {
        var _this = this;
        store.dispatch(new load_main_entities_action_1.LoadMainEntitiesAction(metaFieldId, this.prefix));
        var categoryName = metaFieldId.metaCategoryId.systemName;
        var fieldName = metaFieldId.systemName;
        var fieldNames$ = store
            .select(function (state) { return state.kb.mainEntityFields[_this.prefix]; })
            .pipe(operators_1.filter(skynet_store_utilities_1.notNil), operators_1.filter(function (value) { return value.has(categoryName); }), operators_1.map(function (value) { return value.get(categoryName); }), operators_1.filter(function (value) { return value.has(fieldName); }), operators_1.map(function (value) { return value.get(fieldName); }));
        var compoundCategory$;
        if (skynet_store_utilities_1.notNil(compoundCategory)) {
            compoundCategory$ = of_1.of(compoundCategory);
        }
        else {
            compoundCategory$ = this.selectOne(store, fieldName, categoryName).pipe(operators_1.filter(skynet_store_utilities_1.notNil), operators_1.map(function (metaField) { return metaField.mainEntityCategoryId; }), skynet_store_utilities_1.assert(skynet_store_utilities_1.notNil, Error(fieldName + " is not Main entity")));
        }
        return combineLatest_1.combineLatest(fieldNames$, compoundCategory$).pipe(operators_1.switchMap(function (_a) {
            var fieldNames = _a[0], compound = _a[1];
            return _this.selectAll(store, compound.systemName).pipe(operators_1.map(function (fields) {
                return fields.filter(function (field) {
                    return fieldNames.has(field.metaFieldId.systemName);
                });
            }));
        }), operators_1.publishReplay(1), operators_1.refCount(), operators_1.distinct());
    };
    FieldStoreManager.prototype.clearCache = function () {
        _super.prototype.clearCache.call(this);
        this.loadMainEntityFields['cache'].clear();
    };
    __decorate([
        lodash_decorators_1.Memoize(mainEntityKey),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [store_1.Store, Object, Object]),
        __metadata("design:returntype", Observable_1.Observable)
    ], FieldStoreManager.prototype, "loadMainEntityFields", null);
    return FieldStoreManager;
}(skynet_store_manager_1.DynamicEntityStoreManager));
exports.FieldStoreManager = FieldStoreManager;
//# sourceMappingURL=field-store.manager.js.map